module.exports = __webpack_public_path__ + "static/media/payment-request-logo.9ff1be46.png";